export default __webpack_public_path__ + "fef4daaaf767627e7bf59a30b3110822.svg";